import { I18N } from 'aurelia-i18n';
import I18nConfigLabelService from '~/utils/i18n-config-label-service';
import { autoinject } from 'aurelia-dependency-injection';
import { NavigationInstruction, Next, PipelineStep } from 'aurelia-router';
import { Authentication } from '~/authentication/authentication';
import { Logger } from '~/utils/logger';
import { EventAggregator } from 'aurelia-event-aggregator';

/**
 * This PipelineStep aimed to replace strings in i18n translation files with the alias from Configuration table.
 * In this step, we only replace namespace of common-strings as it is loaded by default.
 * for form-level namespaces, they are processed under i18n-form.ts because their namespaces
 * are loaded dynamically and not always available.
 */
@autoinject
export class ReplaceConfigLabelStep implements PipelineStep {
	public static readonly Events = {
		ConfigLabel: 'config-label',
	};
	constructor(
		protected readonly i18nConfigLabelService: I18nConfigLabelService,
		protected readonly i18n: I18N,
		protected readonly authentication: Authentication,
		protected readonly eventAggregator: EventAggregator,
	) {}
	public run(instruction: NavigationInstruction, next: Next): Promise<any> {
		if (this.authentication.isLoggedIn()) {
			// Ideally there should be .finally() statement in the end of promise
			// to avoid duplicate next() call in then() and catch(). But somehow
			// aurelia router always complains that there is no result return from
			// the router pipeline.
			return this.i18nConfigLabelService
				.replaceI18nStringsWithConfigLabel(
					this.i18n,
					I18nConfigLabelService.defaultNameSpace,
				)
				.then((success) => {
					if (success) {
						Logger.log('Successfuly replaced config labels');
						this.eventAggregator.publish(
							ReplaceConfigLabelStep.Events.ConfigLabel,
						);
					}
					return next();
				})
				.catch((error) => {
					Logger.error(error);
					return next();
				});
		}
		return next();
	}
}
